export default [{
  path: '/user/pwdLogin',
  name: 'pwdLogin',
  component: () => import('pages/user/pwdLogin'),
  meta: {
    title: '用户登录'
  }
},{
  path: '/user/login',
  name: 'login',
  component: () => import('pages/user/login'),
  meta: {
    title: '用户登录'
  }
},{
  path: '/user/register',
  name: 'register',
  component: () => import('pages/user/register'),
  meta: {
    title: '用户注册'
  }
},{
  path: '/user/forget',
  name: 'forget',
  component: () => import('pages/user/forget'),
  meta: {
    title: '找回密码'
  }
},{
  path: '/user/agreement',
  name: 'agreement',
  component: () => import('pages/user/agreement'),
  meta: {
    title: '用户协议'
  }
},{
  path: '/user/privacy',
  name: 'privacy',
  component: () => import('pages/user/privacy'),
  meta: {
    title: '隐私协议'
  }
},{
  path: '/user/binding',
  name: 'binding',
  component: () => import('pages/user/binding'),
  meta: {
    title: '绑定手机'
  }
},{
  path: '/user/startUpClasses',
  name: 'startUpClasses',
  component: () => import('pages/user/startUpClasses'),
  meta: {
    title: '初创班级'
  }
}]
